/* Keep the current collection/search state when Shopify switches language. */
(() => {
  const syncReturn = form => {
    if (!form || !form.matches('form.shopify-localization-form')) return;
    const field = form.querySelector('input[name="return_to"]');
    if (field) field.value = window.location.pathname + window.location.search;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('button[name="locale_code"],button[name="language_code"]');
    if (button) syncReturn(button.form);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter && ['locale_code', 'language_code'].includes(event.submitter.name)) syncReturn(event.target);
  }, true);
})();
